const translations = {
    applied: 'Applied'
};

export default translations;
